var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "search",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#78909c",
    points: "357.95 351.03 346.98 361.26 314.42 326.35 302.86 313.95 313.83 303.72 325.39 316.12 357.95 351.03"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#465e66",
    d: "M325.39 316.12c-1.75 1.77-3.55 3.51-5.38 5.22s-3.7 3.39-5.59 5l-11.56-12.4 11-10.23zM359.71 352.67c-1.75 1.77-3.55 3.51-5.38 5.22s-3.7 3.39-5.59 5l-11.56-12.4 11-10.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M370.91,188.21A181.13,181.13,0,0,1,57.53,305.42,181.1,181.1,0,0,1,66.44,49.49c73-68.1,187.82-64.11,255.92,8.91A179.87,179.87,0,0,1,370.91,188.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M337.09,187.1a147.21,147.21,0,0,1-147,142.1q-2.61,0-5.25-.09a149.23,149.23,0,0,1-27.17-3.45,145.62,145.62,0,0,1-47.8-20.08A148.49,148.49,0,0,1,82.31,282.4,147.22,147.22,0,0,1,297.62,81.57a148.87,148.87,0,0,1,15.92,20.34,145.48,145.48,0,0,1,20.11,47.77A148,148,0,0,1,337.09,187.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: "M238.65,103.16A103.19,103.19,0,0,0,98,141.92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e35b1",
    d: "M493.22,502.58a33.33,33.33,0,0,1-22.84,9l-1.19,0A33.27,33.27,0,0,1,445.89,501L322.71,373.65l49-45.73L494.87,455.2A33.58,33.58,0,0,1,493.22,502.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a2a96",
    d: "M497.58,497.62a33.5,33.5,0,0,1-27.2,14l-1.19,0A33.27,33.27,0,0,1,445.89,501L322.71,373.65l7.94-7.41L453.57,493.3a33.27,33.27,0,0,0,23.3,10.59l1.19,0A33.27,33.27,0,0,0,497.58,497.62Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 371.02,
    x2: 487.01,
    y1: 343,
    y2: 458.99,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M305.86,73.88A158.49,158.49,0,0,0,74.07,290.09a157.44,157.44,0,0,0,110.38,50.28c1.89.07,3.77.1,5.65.1A158.49,158.49,0,0,0,305.86,73.88ZM337.09,187.1a147.21,147.21,0,0,1-147,142.1q-2.61,0-5.25-.09A147.26,147.26,0,0,1,89.55,74.33,147.21,147.21,0,0,1,337.09,187.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#465e66",
    d: "M305.86,73.88A158.49,158.49,0,0,0,74.07,290.09a157.44,157.44,0,0,0,110.38,50.28c1.89.07,3.77.1,5.65.1A158.49,158.49,0,0,0,305.86,73.88ZM337.09,187.1a147.21,147.21,0,0,1-147,142.1q-2.61,0-5.25-.09A147.26,147.26,0,0,1,89.55,74.33,147.21,147.21,0,0,1,337.09,187.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6745f4eb44d1c85bcc522e2e0a9775eb.svg";
export { ForwardRef as ReactComponent };